import React from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';

import THEME from '../../../../../constants/theme';

const CleanButton = ({ isForReview, ...rest }) => <Button {...rest} />;

CleanButton.defaultProps = {
  isForReview: false,
};

CleanButton.propTypes = {
  isForReview: PropTypes.bool,
};

export const ButtonDetails = styled(CleanButton)`
  border-radius: 8px !important;
  color: #1973e8 !important;
  font-family: Montserrat !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 1.14 !important;
  letter-spacing: 1.5px !important;
  ${props => props.isForReview && `
    color: ${THEME.white} !important;
    background-color: ${THEME.error} !important;
  `}
`;

export const Container = styled.div`
  display: flex;
  justify-content: flex-end;
`;
